/* eslint-disable */
import * as React from "react";
import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { NotifierCloseAction } from "./NotifierCloseAction";
import { useNotistack } from "../shared";

export const Notifier: React.FC = () => {
  const [displayed, setDisplayed] = useState<number[]>([]);
  const [notifications, , removeSnackbar] = useNotistack();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id) => {
    setDisplayed([...displayed, id]);
  };

  useEffect(() => {
    notifications.forEach((notification) => {
      // Do nothing if snackbar is already displayed
      if (displayed.includes(notification.key)) return;

      // Add action btn close snackbar
      if (notification.options && notification.options.action) {
        notification.options.action = (key) => {
          return <NotifierCloseAction id={key!} closeAction={closeSnackbar} />;
        };
      }

      // Display snackbar using notistack
      enqueueSnackbar(notification.message, notification.options);

      // Keep track of snackbars that we've displayed
      storeDisplayed(notification.key);
      // Dispatch action to remove snackbar
      const autoHideDuration = 3000;
      setTimeout(() => removeSnackbar(notification.key), autoHideDuration);
    });
  }, [notifications]);

  return null;
};
